import '@/assets/css/reset.css'
import '@/assets/css/style.css'
import '@/assets/css/index.css'
import '@/assets/css/fonts.css'
import { createRouter } from '@/router'
import VueLazyload from 'vue-lazyload';

import { createApp } from 'vue'
import pinia from '@/stores/index.js'

import App from '@/App.vue'

const app = createApp(App)

const router = createRouter()
app.use(pinia)
app.use(router)
app.use(VueLazyload, {
  preLoad: 1.3, // 预加载高度比例
  loading: 'path/to/loading.gif', // 加载中占位图
  error: 'path/to/error.png',    // 加载失败占位图
  attempt: 1 // 尝试次数
});
app.mount('#app')
